<script>
  import axios from "axios"
  import { push, querystring } from "svelte-spa-router"
  import { onDestroy, onMount } from "svelte"
  import { tweened } from "svelte/motion"
  import { cubicOut } from "svelte/easing"
  import { queryStringToJSON } from "../../../../../Script/queryString"
  import Footer from "../../../../../Shared/footer.svelte"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import bulkJson from "../../Stores/jsonBulkData"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import FilePage from "./Components/filePage.svelte"
  import Counter from "../../Shared/counter2.svelte"
  import notify from "../../../../../Script/notify"
  import Loader from "../../../../../Shared/Slots/loader.svelte"
  import AuthInput from "../../../../../Shared/authInput.svelte"
  import DocStatusContent from "./Components/docStatusContent.svelte"
  import { fetchBulkStatus, fetchBulkTemplate } from "../../Script/bulkUpload"
  import Tab from "./Components/tab.svelte"
  import RevokeConfirm from "../../../../../Shared/revokeConfirm.svelte"
  import { postRequest } from "../../../../../Script/apiMethods"

  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let jsonDataRevokeSign = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let revokeSignatureInProcess = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let revokeProcess = []
  /**
   * @type {Array<import("../../Script/document").bulkDocument>}
   */
  let revokeInProcess = []
  /**
   * @type {"Document Status"|"Files"} active tab while generating files
   */
  let activeItem = "Revokation Status"
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  let activeDoc = "start"
  /**
   * @type {Number} number of files to be published
   */
  let signatureGenerated = 0
  /**
   * @type {Number} number of files to be published
   */
  let revokedDocuments = 0
  /**
   * @type {Number} number of files to be published
   */
  let failedDocuments = 0
  /**
   * @type {Number} the total number of documents to be uploaded
   */
  let totalDoc = 0
  /**
   * @type {Number} the count which reflects the increment limit of the progress bar
   */
  let incrementLimit
  /**
   * @type {Number} initial width of the progress bar
   */
  let width = 0
  /**
   * @type {Boolean} whether to show toggle or not
   */
  let showLoading = false
  /**
   * @type {String} the text to be shown while loading
   */
  let loadingText
  /**
   * @type {Boolean} whether to show confirmation modal or not
   */
  let showConfirmationModal = false
  /**
   * @type {Boolean} name of the start button
   */
  let startBtnName = "Revoke Documents"
  /**
   * @type {Object} stores the query value in the current url
   */
  let query
  /**
   * Creates a tweened value representing the width of a progress indicator.
   *
   * @param {number} initialValue - The initial value of the tweened width.
   * @param {Object} options - Options for configuring the tween animation.
   * @param {number} options.duration - The duration of the tween animation in milliseconds.
   * @param {function} options.easing - The easing function used for the animation.
   * @returns {Object} - A tweened value object that represents the width of the progress indicator.
   */
  const widthofProgress = tweened(0, {
    duration: 400,
    easing: cubicOut,
  })
  /**
   * @type {String} validation code for revokation signature
   */
  let signProxyPass

  let revokeReason = ""

  let hideRevokedDoc = false

  onMount(async () => {
    try {
      // Set showLoading to true to indicate loading state
      showLoading = true
      // Set loadingText to indicate the current loading step
      loadingText = " Fetching Bulk Upload data&nbsp;&nbsp;"
      // Parse the query string into a JavaScript object
      query = queryStringToJSON($querystring)

      // Redirect to the bulk publishing page if the "id" parameter is missing in the query
      if (!query.id) {
        push("/publish/bulk")
        return
      }

      // Fetch data about the bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Redirect based on the status of the bulk publishing
      if (apiData.status == "started") {
        if (!apiData.generateFile) push(`/publish/bulk/upload-file?id=${query.id}`)
        else push(`/publish/bulk/generate-file?id=${query.id}`)
        return
      }

      if (apiData.status == "uploaded") {
        push(`/publish/bulk/sign-publish?id=${query.id}`)
        return
      }

      if (apiData.status == "revoked") {
        push(`/documents/bulk/view-report?id=${query.id}`)
        return
      }

      // Fetch data about the bulk template using the "id" from the query
      let bulkData = await fetchBulkTemplate(query.id)

      // Update the $bulkJson array with documents from the fetched bulk data
      $bulkJson = [...bulkData.documents]

      // Initialize the "isDocumentFailed" property for each document
      for (let i = 0; i < $bulkJson.length; i++) {
        $bulkJson[i].isDocumentFailed = false
      }

      totalDoc = $bulkJson.length

      let tobeProcessed = []
      // Filter documents that have not been signed or revoked
      tobeProcessed = $bulkJson.filter((a) => !a.txidRevoked)

      if (!tobeProcessed.length) {
        // All documents have been signed and revoked
        activeDoc = "completed"
        signatureGenerated = revokedDocuments = $bulkJson.length
        return
      }

      if (tobeProcessed.length != $bulkJson.length) startBtnName = "Resume"

      // Count documents with signatures generated and revoked
      signatureGenerated = revokedDocuments = $bulkJson.length - tobeProcessed.length

      // Calculate the increment limit for progress
      incrementLimit = 100 / ($bulkJson.length * 2)

      // changing the width of the ongoing file generation process
      changeWidth(signatureGenerated + revokedDocuments)

      // Store filtered documents in jsonDataRevokeSign
      jsonDataRevokeSign = [...tobeProcessed]
    } catch (error) {
      const info = "PAGE: Bulk Revoke\nEVENT: onMount"
      notify.danger(error, info)
      push("/publish/bulk")
    } finally {
      // Set showLoading to false to indicate that loading is complete
      showLoading = false
    }
  })

  /**
   * Function to update the width of a progress indicator based on the given times.
   * @param {number} times - The number of times to increment the width.
   */
  const changeWidth = (times = 1) => {
    // Check if the increment limit exists
    if (incrementLimit) {
      // Increase the width by the increment limit
      width = width + incrementLimit * times

      // Set the updated width to a variable called "widthofProgress"
      widthofProgress.set(width)

      // Check if the width has reached or exceeded 99%
      if (Math.round(width) >= 99) {
        // Check if the total documents match the sum of revoked and failed documents
        if (totalDoc == revokedDocuments + failedDocuments) {
          // If there are failed documents, set the activeDoc to "retry," otherwise set it to "completed"
          if (failedDocuments) activeDoc = "retry"
          else activeDoc = "completed"
        }
      }
    }
  }

  /**
   * Function to initiate a document processing workflow.
   * It checks various conditions to determine whether to continue the processing or not.
   */
  const initiateProcess = () => {
    // Filter documents that have not been signed, not revoked, or not failed
    let tobeProcessed = $bulkJson.filter((a) => !a.revokationSignature || !a.txidRevoked || !a.isDocumentFailed)
    // Check if there is data in jsonDataRevokeSign, or if there are documents to be processed,
    // and whether the processing queues or arrays have data
    if (jsonDataRevokeSign.length || (tobeProcessed.length && failedDocuments != totalDoc && revokedDocuments != totalDoc) || revokeInProcess.length) assignData2Array()
    else {
      clearInterval(timer)
      // If none of the processing conditions are met, end the processing
      console.timeEnd("revoke")
      return
    }
  }

  onDestroy(() => {
    clearInterval(timer)
  })

  /**
   * Function for assigning data to respective array
   */
  const assignData2Array = () => {
    // Get the number of hardware threads available for concurrency
    let hwc = window.navigator.hardwareConcurrency

    // Check if there are available slots for document revokation signature processing
    if (revokeSignatureInProcess.length < hwc) {
      // Extract a portion of data from jsonDataRevokeSign to fill available slots
      let sArray = jsonDataRevokeSign.splice(0, hwc - revokeSignatureInProcess.length)

      // Add the extracted data to the revokation signature processing queue
      revokeSignatureInProcess = [...revokeSignatureInProcess, ...sArray]

      // Start processing revokation signatures for the extracted data
      for (let i = 0; i < sArray.length; i++) {
        getRevokationSignature(sArray[i])
      }
    }

    // Check if there are available slots for document revokation
    if (revokeInProcess.length < hwc) {
      // Extract a portion of data from revokeProcess to fill available slots
      let pArray = revokeProcess.splice(0, hwc - revokeInProcess.length)

      // Add the extracted data to the revokation processing queue
      revokeInProcess = [...revokeInProcess, ...pArray]

      // Start processing document revokation for the extracted data
      for (let i = 0; i < pArray.length; i++) {
        initiateRevoke(pArray[i])
      }
    }

    // Request animation frame to continue the processing
    // window.requestAnimationFrame(initiateProcess)
  }

  /**
   * Function to generate a revokation signature for a document.
   * @param {import("../../Script/document").bulkDocument} data
   */
  const getRevokationSignature = async (data) => {
    try {
      // Generate the document revokation signature using the 'generateSignature' function
      let apiData = await generateRevokationSignature(data)

      // Find the document entry to be updated in the '$bulkJson' array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      // Update the document entry with the generated signature
      tobeUpdated.revokationSignature = apiData

      // Increment the count of signature-generated documents
      signatureGenerated++

      // Update the progress width
      changeWidth()

      // Add the document to the revokation process queue
      revokeProcess.push(tobeUpdated)

      // Remove the document from the '$bulkJson' array
      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Reconstruct the '$bulkJson' array with the updated document entry
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // $bulkJson = [...$bulkJson.filter((a) => a.id != data.id), tobeUpdated]
    } catch (error) {
      // Handle errors that occur during signature generation
      // failedDocuments++

      // Update the progress width with a factor of 2

      // Find the document entry to be updated in the '$bulkJson' array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      // Set the 'isDocumentFailed' flag to true and store the error message
      tobeUpdated.isDocumentFailed = true
      tobeUpdated.errorMsg = error

      // Remove the document from the '$bulkJson' array
      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Reconstruct the '$bulkJson' array with the updated document entry
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length

      changeWidth(2)

      // Replace the old entry with the updated one in the '$bulkJson' array
      // $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]
    } finally {
      // Remove the document from the revokation signature processing queue
      revokeSignatureInProcess = revokeSignatureInProcess.filter((a) => a.id != data.id)
    }
  }

  /**
   * Function to generate a revokation signature for a document.
   * @param {import("../../Script/document").bulkDocument} jsonData
   * @returns {Promise} A promise that resolves with the generated revokation signature data or rejects with an error.
   */
  const generateRevokationSignature = (jsonData) => {
    return new Promise(async (resolve, reject) => {
      try {
        // Check if the client is online; throw a network error if not
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        // Make an HTTP POST request to the specified URL to generate the revokation signature
        const { data } = await axios.post(
          `/api/swagger/v2/misc/proxy-sign`,
          {
            signProxyPass: signProxyPass,
            msg: `${jsonData.id}`,
          },
          {
            headers: {
              "x-access-token": $ApplicationState.token,
            },
          }
        )

        // const { data } = await axios.get(`https://ecdsa.test.print2block.in/sign/5f5bb3376efc0f44c7090574${jsonData.id}`)

        // Check if the response contains an error and is not successful; throw an error code if so
        if (data.error && !data.success) {
          throw data.errorCode
        }
        // Resolve the promise with the generated signature data
        resolve(data.signature)
      } catch (error) {
        // Modify error codes and reject the promise with the error or a modified error

        reject(error)
      }
    })
  }

  /**
   * Initiates the revokation process for a document.
   * @param {import("../../Script/document").bulkDocument} data
   */
  const initiateRevoke = async (data) => {
    try {
      // Revoke the document and get the API response
      const apiData = await postRequest(
        `/api/swagger/v2/documents/${data.id}/revoke`,
        { signature: data.revokationSignature, revokeReason, hideRevokedDoc },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )

      revokedDocuments++
      changeWidth()

      // Find the document to be updated in the $bulkJson array
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]
      tobeUpdated.txidRevoked = apiData.txidRevoked

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      // $bulkJson = [...$bulkJson.filter((a) => a.id != data.id), tobeUpdated]
    } catch (error) {
      // Handle errors during the revokation process
      // failedDocuments++
      let tobeUpdated = $bulkJson.filter((a) => a.id == data.id)[0]

      tobeUpdated.isDocumentFailed = true
      tobeUpdated.errorMsg = error

      let tempJson = $bulkJson.filter((a) => a.id != data.id)

      // Replace the old entry with the updated one in the '$bulkJson' array
      $bulkJson = [...tempJson.filter((a) => a.isDocumentFailed), tobeUpdated, ...tempJson.filter((a) => !a.isDocumentFailed)]

      failedDocuments = $bulkJson.filter((a) => a.isDocumentFailed).length

      changeWidth()

      // Replace the old entry with the updated one in the '$bulkJson' array
      // $bulkJson = [tobeUpdated, ...$bulkJson.filter((a) => a.id != data.id)]
    } finally {
      // Remove the document from the revokeInProcess array
      revokeInProcess = revokeInProcess.filter((a) => a.id != data.id)
    }
  }

  let timer

  /**
   * Confirm the authentication code entered by the user.
   * Extracts the code from the input fields, hides the confirmation modal, and triggers a specific function.
   * @param {Event} e - The event object, representing the form submission.
   */
  const confirmAuthCode = async (e) => {
    try {
      const revokeDetails = e.detail

      // Send a POST request to validate the verification using axios
      const data = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          otp: revokeDetails.code,
        },
        {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        }
      )

      signProxyPass = data.signProxyPass

      revokeReason = revokeDetails.revokeReason
      hideRevokedDoc = revokeDetails.hideRevokedDoc

      // Hide the confirmation modal
      showConfirmationModal = false

      console.time("revoke")

      // Set the activeDoc status to "processing"
      activeDoc = "processing"

      // Call the initiateProcess function
      // initiateProcess()

      timer = setInterval(initiateProcess, 30)
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Bulk Revoke\nEVENT: While initiating bulk revokation"
      notify.danger(error, info)
    }
  }

  /**
   * Navigate to the specified route based on the bulk revoking status.
   */
  const navigateReportPage = async () => {
    try {
      showLoading = true
      // Fetch bulk publishing status using the "id" from the query
      let apiData = await fetchBulkStatus(query.id)

      // Check if the bulk publishing status is "published"
      if (apiData.status == "revoked") push(`/documents/bulk/view-report?id=${query.id}`)
      else window.location.reload()
    } catch (error) {
      const info = "PAGE: Bulk Revoke\nEVENT: While updating bulk status before navigating to report"
      notify.danger(error, info)
      // Redirect to the bulk publishing page in case of an error
      push("/documents/bulk")
    } finally {
      showLoading = false
    }
  }
</script>

<svelte:head>
  <title>Bulk Revoke</title>
</svelte:head>

{#if showConfirmationModal}
  <RevokeConfirm
    on:submit={confirmAuthCode}
    on:close={() => {
      showConfirmationModal = false
    }}
  />
{/if}

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col rounded-md bg-white dark:bg-mdGray">
      <Tab {activeDoc} bind:activeItem />

      {#if showLoading}
        <div class="flex h-full items-center justify-center text-base text-gray-400">
          <Loader>
            <span class="flex">
              {@html loadingText}
            </span>
          </Loader>
        </div>
      {:else}
        <div class="flex h-full w-full select-none flex-col items-center justify-center p-6 mobile:p-12">
          <div class="grid w-full grid-cols-2 justify-center gap-3 xl:gap-6">
            <Counter titleText="TOTAL DOCUMENTS" count={totalDoc} span="col-span-2" color="#ff6a00" gradient="#f8a500, #ff6a00" icon="fa-file-lines" />
            <Counter titleText="SIGNATURES GENERATED" count={signatureGenerated} span="col-span-2" color="#00B2FF" gradient="#A3E3FF, #00B2FF" icon="fa-gear {activeDoc == 'processing' && signatureGenerated != totalDoc ? 'fa-spin' : ''}" />
            <Counter titleText="DOCUMENTS REVOKED" count={revokedDocuments} span="col-span-2" color="#00D515" gradient="#58FE69, #00D515" icon="fa-file-excel" />
            <Counter titleText="DOCUMENTS FAILED" count={failedDocuments} span="col-span-2" color="#fe036a" gradient="#F87A7A, #F03232" icon="fa-file-exclamation" />
          </div>
          {#if activeItem == "Document Status"}
            <FilePage />
          {:else}
            <DocStatusContent
              {startBtnName}
              {activeDoc}
              width={$widthofProgress}
              on:click={() => {
                showConfirmationModal = true
              }}
              on:viewReport={navigateReportPage}
            />
          {/if}
        </div>
      {/if}

      {#if activeDoc == "processing"}
        <h1 class="pb-6 text-center text-base font-medium text-red-500 mobile:pb-12">Please don't refresh the page while in progress.</h1>
      {/if}
    </div>
  </div>

  <Footer />
</div>
